import type { ClientBonusTerms } from "@/lib/partners/client-bonus-terms"
import { roundPercent } from "@/lib/partners/percent"
import { createTranslator, type useTranslations } from "next-intl"
import english from "@/translations/en/partner-bonus.json"

const englishTranslator = createTranslator({locale: "en", messages: english, namespace: "PartnerBonus"})

/** What a referred client is told about its bonus, on the Billing page and right after signup. */
export function describeClientBonusTerms({ percent, paymentsLeft }: ClientBonusTerms, t: ReturnType<typeof useTranslations<"PartnerBonus">> = englishTranslator, locale = "en"): string {
  const share = new Intl.NumberFormat(locale, {maximumFractionDigits: 2}).format(roundPercent(percent))
  switch (paymentsLeft) {
    case null:
      return t("clientEveryPayment", {share})
    case 1:
      return t("clientNextPayment", {share})
    default:
      return t("clientNextPayments", {share, count: paymentsLeft})
  }
}
